import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CommonService } from 'src/app/services/common.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-diport-input-dialog',
  templateUrl: './diport-input-dialog.component.html',
  styleUrls: ['./diport-input-dialog.component.scss']
})
export class DIPortInputDialogComponent {
  port: number;
  portExists: boolean = false;
  private portInputSubject = new Subject<number>();

  constructor(
    public dialogRef: MatDialogRef<DIPortInputDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commonService: CommonService,
    private ngxuiloader: NgxUiLoaderService,
    private toastr: ToastrService
  ) {
    this.portInputSubject.pipe(debounceTime(1000)).subscribe((port) => {
      this.checkPortExists(port);
    });
  }

  onPortInput(event: Event) {
    const port = (event.target as HTMLInputElement).value;
    if (port && !isNaN(+port)) {
      this.portInputSubject.next(+port);
    }
  }

  private checkPortExists(port: number) {
    const portlength = port.toString().length;
    if (this.data.vbAgentid && portlength >= 3) {
      this.ngxuiloader.start();
      this.commonService.GetVBCheckPortExists(this.data.vbAgentid, port).subscribe(
        (data) => {
          this.ngxuiloader.stop();
          if (data.status === 'success') {
            const obj = JSON.parse(data['responsebody']);
            this.portExists = obj['status'] === 'failure';
            if (this.portExists) {
              this.toastr.error("Port already exists", "Please enter valid port", {
                positionClass: "toast-bottom-right",
                timeOut: 4000,
              });
            }
          }
        },
        (error) => {
          this.ngxuiloader.stop();
          this.toastr.error("Failure", "An error occurred while checking the port", {
            positionClass: "toast-bottom-right",
            timeOut: 4000,
          });
        }
      );
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (!this.portExists) {
      this.dialogRef.close(this.port);
    }
  }
}